import React__default from "react";
import clsx from "clsx";
const CardTop = (props) => {
  const { children, className } = props;
  return /* @__PURE__ */ React__default.createElement("div", { className: clsx("card__top", className) }, children);
};
export {
  CardTop
};
